import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import React from 'react';
import {WishlistHeaderBannerView} from './WishlistHeaderBannerView';
import {useWishlistHeaderBanner} from './hooks/useWishlistHeaderBanner';

export const WishlistHeaderBanner = (props: PriorityConfig) => {
  return (
    <DataFetcher
      View={WishlistHeaderBannerView}
      Loading={() => null}
      Error={() => null}
      request={useWishlistHeaderBanner()}
      renderingPriority={props.renderingPriority}
    />
  );
};
